import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import DeliveryFields from "./DeliveryFields";
import { useDeliveryPlan } from "./useDeliveryPlan";

export default function BoostDialog({ post, connection, onClose, mutation }) {
  const plan = useDeliveryPlan();

  const submit = () =>
    mutation.mutate(
      {
        connectionId: connection.id,
        sourcePostId: post.id,
        instagram: post.source === "INSTAGRAM",
        ...plan.payload,
      },
      { onSuccess: onClose }
    );

  return (
    <Dialog
      open={Boolean(post)}
      onClose={mutation.isLoading ? undefined : onClose}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>Boost this post</DialogTitle>
      <DialogContent className="space-y-3">
        <p className="pt-2 text-xs uppercase tracking-wide text-app-text-muted">
          Account: {connection.label}
        </p>
        {post ? (
          <p className="line-clamp-2 text-sm text-app-text-secondary">
            {post.text || "Post without a caption"}
          </p>
        ) : null}
        <DeliveryFields plan={plan} currency={connection.currency} subject="boost" />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={mutation.isLoading}>
          Cancel
        </Button>
        <Button variant="contained" disabled={!plan.valid || mutation.isLoading} onClick={submit}>
          {mutation.isLoading ? "Creating…" : "Create paused boost"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
